import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ambassadorRegisterReq, getAmbassadorPayoutsReq, ambassadorRequestPayoutReq, getAmbassadorReferralsReq, ambassadorOnboardingLinkReq } from '../ambassador';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Notification from '../../components/Notification';

export const useAmbassadorRegisterMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['ambassador-register'],
        mutationFn: async (data) => {
            const response = await ambassadorRegisterReq({...data});
            return response.data;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['get-ambassador-me'] });
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

// export const useAmbassadorRequestPayoutMutation = () => {
//     return useMutation({
//         mutationKey: ['ambassador-request-payout'],
//         mutationFn: async (data) => {
//             const response = await ambassadorRequestPayoutReq({...data});
//             return response.data;
//         },
//         onSuccess: (data) => {
//         },
//         onError: (error) => {
//             toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
//         },
//     });
// };

export const useAmbassadorOnboardingLinkMutation = () => {
    return useMutation({
        mutationKey: ['ambassador-onboarding-link'],
        mutationFn: async (data) => {
            const response = await ambassadorOnboardingLinkReq({...data});
            return response.data;
        },
        onSuccess: (data) => {
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

// export const useAmbassadorPayoutsQuery = () => {
//     const dispatch = useDispatch();
//     const { isLoading, data } = useQuery({
//         queryKey: ['get-payouts'],
//         queryFn: async () => {
//             try {
//                 const response = await getAmbassadorPayoutsReq();
//                 return response;
//             } catch (error) {
//                 console.error('Error fetching payouts:', error);
//                 throw error;
//             }
//         },
//         retry: false,
//         refetchOnWindowFocus: false,
//     });

//     return { isLoading, data };
// };

// export const useAmbassadorReferralsQuery = () => {
//     const dispatch = useDispatch();
//     const { isLoading, data } = useQuery({
//         queryKey: ['get-referrals'],
//         queryFn: async () => {
//             try {
//                 const response = await getAmbassadorReferralsReq();
//                 return response;
//             } catch (error) {
//                 console.error('Error fetching referrals:', error);
//                 throw error;
//             }
//         },
//         retry: false,
//         refetchOnWindowFocus: false,
//     });

//     return { isLoading, data };
// };